export default __webpack_public_path__ + "static/media/dfmLinéaire.a94f831c.png";